import React, { useState } from 'react';
import { api } from '../../api';
import { colors, fontFamily } from '../../theme';

const card = { background: colors.cardBg, border: `1px solid ${colors.goldMuted}`, borderRadius: 8, padding: '1.5rem', boxShadow: colors.shadowCard };

const DatabaseExport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const run = async (fn, successMsg) => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(null);
      await fn();
      setSuccess(successMsg);
    } catch (err) {
      setError(err.response?.data?.error || 'Export failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ fontFamily, color: colors.textPrimary }}>
      <h2 style={{ color: colors.textPrimary, marginBottom: '1.25rem', fontSize: '1.3rem' }}>Database Export</h2>

      {error && <div style={{ background: 'rgba(220,53,69,0.1)', border: `1px solid ${colors.negative}`, color: colors.negative, borderRadius: 6, padding: '0.75rem', marginBottom: '1rem' }}>{error}</div>}
      {success && <div style={{ background: 'rgba(40,167,69,0.1)', border: `1px solid ${colors.odds}`, color: colors.odds, borderRadius: 6, padding: '0.75rem', marginBottom: '1rem' }}>{success}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '1.25rem' }}>
        <div style={card}>
          <h3 style={{ color: colors.textPrimary, margin: '0 0 0.75rem 0', fontSize: '1rem' }}>SQLite Database</h3>
          <p style={{ color: colors.textMuted, fontSize: '0.85rem', marginBottom: '1rem', lineHeight: 1.5 }}>
            Download a complete copy of the SQLite database file.
          </p>
          <div style={{ background: 'rgba(255,193,7,0.1)', border: '1px solid rgba(255,193,7,0.3)', borderRadius: 4, padding: '0.6rem 0.75rem', color: colors.pending, fontSize: '0.82rem', marginBottom: '1rem' }}>
            This file contains sensitive data. Handle with care.
          </div>
          <button
            onClick={() => run(api.admin.downloadDatabase, 'Database downloaded successfully')}
            disabled={loading}
            style={{ width: '100%', padding: '0.75rem', background: colors.goldActiveBg, border: `1px solid ${colors.gold}`, color: colors.textPrimary, borderRadius: 4, cursor: loading ? 'not-allowed' : 'pointer', fontWeight: 600, opacity: loading ? 0.5 : 1, fontFamily, fontSize: '0.9rem' }}
          >
            {loading ? 'Downloading...' : 'Download Database (.db)'}
          </button>
        </div>

        <div style={card}>
          <h3 style={{ color: colors.textPrimary, margin: '0 0 0.75rem 0', fontSize: '1rem' }}>JSON Export</h3>
          <p style={{ color: colors.textMuted, fontSize: '0.85rem', marginBottom: '0.75rem', lineHeight: 1.5 }}>
            Export all data as a structured JSON file.
          </p>
          <div style={{ background: colors.sectionBg, border: `1px solid ${colors.goldMuted}`, borderRadius: 4, padding: '0.75rem', marginBottom: '1rem' }}>
            <p style={{ color: colors.textMuted, fontSize: '0.78rem', margin: '0 0 0.5rem 0' }}>Includes:</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.2rem' }}>
              {['Users', 'Bets', 'Parlays', 'Transactions', 'Messages', 'Billing Configs', 'Billing Periods', 'Billing Records'].map(item => (
                <span key={item} style={{ color: colors.textPrimary, fontSize: '0.8rem' }}>• {item}</span>
              ))}
            </div>
          </div>
          <button
            onClick={() => run(api.admin.exportJson, 'JSON export downloaded successfully')}
            disabled={loading}
            style={{ width: '100%', padding: '0.75rem', background: colors.cardBg, border: `1px solid ${colors.goldMuted}`, color: colors.textMuted, borderRadius: 4, cursor: loading ? 'not-allowed' : 'pointer', fontWeight: 600, opacity: loading ? 0.5 : 1, fontFamily, fontSize: '0.9rem' }}
          >
            {loading ? 'Exporting...' : 'Export JSON'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DatabaseExport;
